import script from "./ExamenCliniqueForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamenCliniqueForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__